import { RouteConfig } from "vue-router";

import Layout from "@/layout/index.vue";

const scoreSttingsRouter: RouteConfig = {
  path: "/pushSettings",
  component: Layout,
  meta: {
    title: "微信推送设置",
    icon: "setting",
    permission: "Pages.Settings"
  },
  children: [
    {
      path: "pushPermission",
      name:'pushPermission',
      component: () =>
        import(
          /* webpackChunkName: "score-settings" */ "@/views/push-settings/index.vue"
        ),
      meta: {
        title: "功能性开关管理",
        icon: "setting",
        permission: "Pages.Settings"
      }
    },
  ]
};

export default scoreSttingsRouter;
